import { useNavigate } from "react-router-dom";
import usePageTitle from "../../utils/hooks/usePageTitle";
import { MdBusiness, MdBugReport } from "react-icons/md";

/**
 * Signup selection page that allows users to choose between
 * Business and Security Pentester roles before registration
 */
const RegisterSelectionPage = () => {
  const navigate = useNavigate();
  usePageTitle("Sign Up");

  const handleBusinessSignup = () => {
    navigate("/register/business");
  };

  const handleResearcherSignup = () => {
    navigate("/register/researcher");
  };

  return (
    <article className="mx-auto w-full max-w-5xl font-montserrat">
      {/* Header Section */}
      <div className="mb-12 text-center">
        <h1 className="mb-4 text-4xl font-bold text-blue-600" style={{ fontFamily: 'Montserrat' }}>
          Capture The Bug
        </h1>
        <p className="mb-2 text-lg text-gray-800 font-medium" style={{ fontFamily: 'Montserrat' }}>
          Are you a Business or a Penetration Tester?
        </p>
        <p className="text-sm text-gray-600" style={{ fontFamily: 'Montserrat' }}>
          Already have an account?{" "}
          <button
            onClick={() => navigate("/login")}
            className="font-medium text-blue-600 hover:text-blue-700 hover:underline"
            style={{ fontFamily: 'Montserrat' }}
          >
            Log in here
          </button>
        </p>
      </div>

      {/* Selection Cards Grid */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {/* Business Card */}
        <div className="relative flex flex-col rounded-xl border border-gray-200 bg-white p-8 shadow-sm transition-all hover:shadow-lg" style={{ fontFamily: 'Montserrat' }}>
          {/* Badge */}
          <div className="absolute bg-blue-200 px-3 py-1 rounded-lg" style={{ top: '10px', right: '10px', fontFamily: 'Montserrat' }}>
            <span className="text-xs font-semibold text-blue-700" style={{ fontFamily: 'Montserrat' }}>
              for Business
            </span>
          </div>

          {/* Icon */}
          <div className="mb-6 mt-6 flex h-14 w-14 items-center justify-center rounded-lg bg-[#58CC024D] bg-opacity-30">
            <MdBusiness className="text-2xl text-green-600" />
          </div>

          {/* Title */}
          <h2 className="mb-3 text-lg font-semibold text-gray-900" style={{ fontFamily: 'Montserrat' }}>
            Capture The Bug
          </h2>

          {/* Description */}
          <p className="mb-8 flex-1 text-sm text-gray-600 leading-relaxed" style={{ fontFamily: 'Montserrat' }}>
            Secure your applications with <b>Penetration Testing as a Service (PTaaS)</b> - built for modern security teams that need speed, quality, and visibility.
          {/* Secure apps with <b>PTaaS</b>: on-demand web, mobile, API, and infrastructure testing. Collaborate with in-house pentesters for fast, actionable insights. */}
          </p>

          {/* Sign Up Button */}
          <button
            onClick={handleBusinessSignup}
            className="w-full rounded-md bg-[#010D2C] px-4 py-3 text-sm font-medium text-white transition-colors hover:bg-[#0e1d40] focus:outline-none focus:ring-2 focus:ring-[#010D2C] focus:ring-offset-2"
            style={{ fontFamily: 'Montserrat' }}
          >
            Sign Up
          </button>
        </div>

        {/* Pentester Card */}
        <div className="relative flex flex-col rounded-xl border border-gray-200 bg-white p-8 shadow-sm transition-all hover:shadow-lg" style={{ fontFamily: 'Montserrat' }}>
          {/* Badge */}
          <div className="absolute bg-blue-200 px-3 py-1 rounded-lg" style={{ top: '10px', right: '10px', fontFamily: 'Montserrat' }}>
            <span className="text-xs font-semibold text-blue-700" style={{ fontFamily: 'Montserrat' }}>
              for Pentester
            </span>
          </div>

          {/* Icon */}
          <div className="mb-6 mt-6 flex h-14 w-14 items-center justify-center rounded-lg bg-[#58CC024D] bg-opacity-30">
            <MdBugReport className="text-2xl text-green-600" />
          </div>

          {/* Title */}
          <h2 className="mb-3 text-lg font-semibold text-gray-900" style={{ fontFamily: 'Montserrat' }}>
            Capture The Bug
          </h2>

          {/* Description */}
          <p className="mb-8 flex-1 text-sm text-gray-600 leading-relaxed" style={{ fontFamily: 'Montserrat' }}>
            Join our <b>PTaaS platform</b> to conduct real-world security assessments,
            collaborate with our team, and help businesses strengthen their
            defenses.
          </p>

          {/* Sign Up Button */}
          <button
            onClick={handleResearcherSignup}
            className="w-full rounded-md bg-[#010D2C] px-4 py-3 text-sm font-medium text-white transition-colors hover:bg-[#0e1d40] focus:outline-none focus:ring-2 focus:ring-[#010D2C] focus:ring-offset-2"
            style={{ fontFamily: 'Montserrat' }}
          >
            Sign Up
          </button>
        </div>
      </div>
    </article>
  );
};

export default RegisterSelectionPage;

